<template>
  <div>
    <ControlPanel :title="'Раздел: Справочники'" :icon="'mdi mdi-folder'" :links="links">
    </ControlPanel>
    <div class="container-fluid">
      <Category>
        <template v-slot:pos1>
          <p>Здесь вы можете заполнить справочники о ваших организациях и сотрудниках этих организаций.</p>
        </template>
        <template v-slot:pos2>
          <table class="table table-sm table-bordered">
            <tr>
              <td><b-link to="/registers/organizations/">Справочник организаций</b-link></td>
            </tr>
            <tr>
              <td><b-link to="/registers/groups/">Справочник подразделений</b-link></td>
            </tr>
            <tr>
              <td><b-link to="/registers/workers/">Справочник сотрудников</b-link></td>
            </tr>
          </table>
        </template>
      </Category>
    </div>
  </div>
</template>

<script>
import ControlPanel from "@/components/base/ControlPanel";
import Category from "@/components/base/Category";
import {mapGetters} from "vuex";

export default {
  name: 'RegistersDefault.vue',
  components: {
    ControlPanel,
    Category
  },
  data: function () {
    return {

    }
  },
  computed:  {
    ...mapGetters({
      links: 'links'
    })
  },
}
</script>

<style scoped>

</style>
